export const features = {
    "template": "template1",
    "companyName": "Georgia Stern Insurance Brokerage (UAT)",
    "inowEndpoint": "https://uatgoapp.gsiay.com",
    "tokenIssuer": "https://gsia-inow.oktapreview.com/oauth2/default",
    "clientId": "0oamj101ws7XAkFr11d7",
    "features": {
        "CustomContentPage1": false,
        "CustomContentPage2": false,
        "addRegistrationEmail": true,
        "affiliatedCarrierAccess": false,
        "agentEmail": true,
        "agentLink": true,
        "agentPanel": true,
        "blockAchNumberOps": false,
        "cancelFutureScheduledPayments": false,
        "changeCoverage": false,
        "changeCoverageShowNewPremium": true,
        "claimDetailsDocuments": true,
        "claimDetailsPayments": true,
        "claimDocumentUpload": true,
        "claimList": true,
        "claimStatus": true,
        "combinePolicies": true,
        "coverageDetails": true,
        "cpPortalLinking": false,
        "customPrivacyStatement": false,
        "customTOS": false,
        "customerInformation": true,
        "deactivateUserOnly": true,
        "defaultLossDateTime": true,
        "desktopDeliveryPreferencesDefaultExpanded": true,
        "editPayPlan": false,
        "hasOpenBalance": true,
        "loginPanelExpirationDate": "2999-01-01",
        "mfaEnabled": false,
        "mobileDeliveryPreferencesDefaultExpanded": false,
        "needHelp": true,
        "notificationPreferences": false,
        "otherPaymentAmountAllowed": true,
        "paperlessChoiceUpdate": false,
        "passwordResetInfo": true,
        "payPlanTypesToFilter": [
            "Mortgagee",
            "Agent",
            "Statement",
            "Automated",
            "Direct"
        ],
        "pendingOrScheduledPaymentsList": true,
        "policyDetailsAddress": true,
        "policyDetailsAddressTypeCd": [],
        "policyDocumentUpload": true,
        "policyForms": false,
        "policyFormsDownload": false,
        "policyUserAttachmentsDisplay": false,
        "printButtonEnabled": true,
        "recentPaymentsList": true,
        "rememberMe": true,
        "reportClaim": true,
        "scheduledPayments": true,
        "showImageTag": true,
        "showInstallPWA": false,
        "standardPhoneLength": false,
        "unauthenticatedPayments": true,
        "unauthenticatedReportClaim": false,
        "underlyingPoliciesPayPlansEditable": false,
        "useGooglePlacesInReportClaimFlow": true,
        "verifyAddress": true,
        "viewChangeRequests": true,
        "useInsuredAttachments": true
    },
    "keys": {
        "googleAnalytics": "AIzaSyA7H2vIyoqNgbXNS3SP8A8syyNMgGi7KUk",
        "googleAnalytics4": "AIzaSyA7H2vIyoqNgbXNS3SP8A8syyNMgGi7KUk",
        "googleAnalyticsGwDev-deprecated": "",
        "googleAnalytics4GwDev-test": "",
        "googleAnalytics4GwDev": "",
        "googleAnalytics4GwProd": "",
        "googlePlacesApi": "AIzaSyA7H2vIyoqNgbXNS3SP8A8syyNMgGi7KUk"
    },
    "salesPortalUrl": "https://gsia-uat-cp.mu-1-us-west-2.guidewire.net",
    "cpProducts": [
        "Commercial Auto Liability"
    ],
    "paymentTenantName": "tenant.gsia",
    "paymentSdkUrl": "https://js-sdk-prod.payments.guidewire.net/v1/gw-payments-sdk.js",
    "paymentConfigIds": {
        "TBIC": "18414351"
    },
    "paymentMethods": [
        "ACH",
        "CC",
        "UserSelect"
    ],
    "anonymousPaymentMethods": [
        "ACH",
        "CC",
        "UserSelect"
    ],
    "achEntryClassCode": "PPD",
    "processingFee": 0,
    "maxUploadFileSize": "500mb",
    "attachmentTemplatesLimit": "20",
    "policiesCountLimit": "50",
    "billingAccountsCountLimit": "50",
    "policyCreatedSinceDt": 365,
    "policyStatusCd": "Active,Non-Renewed,Non-Renew Requested,Cancel Notice",
    "passwordConstraints": [
        {
            "constraint": "minLength",
            "value": 7,
            "message": "Use at least 7 characters"
        },
        {
            "constraint": "minNumber",
            "value": 1,
            "message": "Contain at least one number"
        },
        {
            "constraint": "minLowerCase",
            "value": 1,
            "message": "Contain at least one lower case letter"
        },
        {
            "constraint": "minUpperCase",
            "value": 1,
            "message": "Contain at least one upper case letter"
        },
        {
            "constraint": "matchUserName",
            "value": 1,
            "message": "Password Must Not Match Username"
        },
        {
            "constraint": "matchPreviousPwd",
            "value": 1,
            "message": "Password Must Not Match Previous Password"
        }
    ],
    "userIdConstraints": [
        {
            "constraint": "minLength",
            "value": 3,
            "message": "Use at least 3 characters"
        }
    ],
    "downTime": {
        "beginTime": "2020-01-01T17:00-05:00",
        "endTime": "2020-12-31T17:00-05:00",
        "title": "<p>System Down for Maintenance</p>",
        "body": "<p>We apologize that our system is currently unavailable. It will remain unavailable from 01/01/2021 to 12/31/2021.</p>"
    },
    "signIn": {
        "title": "<h1>Welcome to the New Service Portal</h1>",
        "body": "<p>Please proceed to make a new account.</p> <p>We hope you enjoy!</p>"
    },
    "notificationSmsNumber": "",
    "billingStatusCd": "Normal, Cancel, Legal",
    "apiResponseSizeLimit": 100,
    "carrierDomains": {},
    "_meta": {
        "build": "4.0.0-3-330e94b",
        "commit": "330e94b00c8c9a401c57e17cefd061862a86ea19",
        "company": "gsia",
        "date": "2025-10-21T14:35:39+00:00",
        "source": "serviceportal-four-config",
        "version": "4.0.0",
        "imageTag": ""
    },
    "paymentApiUrl": "https://midas.api.omega2-andromeda.guidewire.net",
    "faviconFileExtension": "ico"
};